import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterConfirm({ action = 'confirm' }) {
  const token = new URLSearchParams(window.location.search).get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error | already
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('Token fehlt');
      return;
    }
    const endpoint = action === 'unsubscribe' ? 'unsubscribe' : 'confirm';
    axios.get(`${API}/public/newsletter/${endpoint}`, { params: { token } })
      .then(({ data }) => {
        setEmail(data.email || '');
        setStatus(data.already_confirmed ? 'already' : 'success');
      })
      .catch(err => {
        setStatus('error');
        setError(err.response?.data?.detail || 'Ungültiger Link');
      });
  }, [token, action]);

  const labels = action === 'unsubscribe' ? {
    success: 'Abmeldung bestätigt',
    text: 'Du erhältst keine weiteren Newsletter mehr.',
  } : {
    success: 'Anmeldung bestätigt!',
    text: 'Du bist dabei. Den nächsten Newsletter bekommst du in den kommenden Wochen.',
    already: 'Bereits bestätigt',
    alreadyText: 'Deine Anmeldung ist schon aktiv.',
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <p className="text-[#befa0a] text-xs uppercase tracking-[0.3em] font-bold mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
          ENBET Consulting
        </p>
        {status === 'loading' && (
          <p className="text-white/50 text-sm" style={{ fontFamily: "'Manrope', sans-serif" }}>Einen Moment...</p>
        )}
        {status === 'success' && (
          <>
            <div className="w-1.5 h-12 bg-[#befa0a] mx-auto mb-6" />
            <h1 className="text-white text-2xl md:text-3xl font-bold uppercase tracking-tight mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
              {labels.success}
            </h1>
            <p className="text-white/60 mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
              {labels.text}
            </p>
            {email && <p className="text-white/40 text-sm" style={{ fontFamily: "'Manrope', sans-serif" }}>{email}</p>}
            <a href="/" className="inline-block mt-8 text-[#befa0a] hover:underline" style={{ fontFamily: "'Manrope', sans-serif" }}>
              → Zurück zur Website
            </a>
          </>
        )}
        {status === 'already' && (
          <>
            <h1 className="text-white text-2xl md:text-3xl font-bold uppercase tracking-tight mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
              {labels.already}
            </h1>
            <p className="text-white/60" style={{ fontFamily: "'Manrope', sans-serif" }}>{labels.alreadyText}</p>
            <a href="/" className="inline-block mt-8 text-[#befa0a] hover:underline" style={{ fontFamily: "'Manrope', sans-serif" }}>
              → Zurück zur Website
            </a>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="text-white text-2xl md:text-3xl font-bold uppercase tracking-tight mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Fehler
            </h1>
            <p className="text-red-400 text-sm" style={{ fontFamily: "'Manrope', sans-serif" }}>{error}</p>
            <a href="/" className="inline-block mt-8 text-[#befa0a] hover:underline" style={{ fontFamily: "'Manrope', sans-serif" }}>
              → Zurück zur Website
            </a>
          </>
        )}
      </div>
    </div>
  );
}
